import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GrupoDetalharComponent } from './grupo-detalhar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: GrupoDetalharComponent }
    ])],
    exports: [RouterModule]
})
export class GrupoDetalharRoutingModule { }
